<template>
  <svg :width="width" :height="height" viewBox="0 0 20 20" :fill="`${color ? color : '#ffffff'}`"  xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_9141_21813)">
      <path d="M10.0006 10.9766L14.1256 6.85156L15.3039 8.0299L10.0006 13.3332L4.69727 8.0299L5.8756 6.85156L10.0006 10.9766Z"  :fill="` ${color ? color : '#ffffff'}`" />
    </g>
    <defs>
      <clipPath id="clip0_9141_21813">
        <rect width="20" height="20"  :fill="` ${color ? color : '#ffffff'}`" />
      </clipPath>
    </defs>
  </svg>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
@Component({
  name: 'WcIconReset'
})
export default class extends Vue {
  @Prop({ default: '#ffffff' }) color!: String
  @Prop({ default: '20' }) width!: String
  @Prop({ default: '20' }) height!: String
}
</script>

<style scoped>
</style>
